import { AnyObject } from '../types';

export function toBoolean(value: AnyObject): boolean{
  return ['1', 'y', 'true', 's'].includes(value?.toString()?.toLowerCase());
}
